import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IStore from '@meronex/icons/mdc/MdcWarehouse';
import TopHeader from '../../../views/components/TopHeader';

import { storesMng } from '../../api/storesMng';
import { App } from '@meronex/app';
import StoreForm from './StoreForm';

// Fields that only ever live on the client: `isValid` comes from the form,
// the rest are dashboard figures StoresView attaches for the stat cards.
// None belong in the store document.
const DISPLAY_ONLY_FIELDS = [
  'isValid',
  'totalValue',
  'transactionCount',
  'outOfStockCount',
  'lowStockCount',
];

function EditStoreDialog(props) {
  const { open, onClose, onEdit, store } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({ isValid: true });

  React.useEffect(() => {
    setFormData({ ...store });
  }, [store]);

  const _onClose = () => {
    onClose();
  };
  const editStore = async () => {
    setLoading(true);
    const _updateStore = Object.assign({}, store, formData);
    // StoresView enriches store objects with dashboard values for display only
    // (see StoresView "Enrich stores with dashboard data"). They are not part of
    // the store document and updateStore's schema rejects them, so drop them here.
    DISPLAY_ONLY_FIELDS.forEach((f) => delete _updateStore[f]);
    try {
      const result = await storesMng.updateStore(_updateStore);
      onEdit();
      onClose();
      App.eventsManager.emit('event-refresh-views', EditStoreDialog.name, {
        activeView: 'stores',
      });
      App.eventsManager.emit('event-sites-loaded', EditStoreDialog.name);
      toast.success('Store updated', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error(e && e.reason ? `Could not save store: ${e.reason}` : 'Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (!store || !open) {
    return null;
  }
  return (
    <Dialog
      fullWidth
      className={'fullScreenMobile'}
      open={open}
      onClose={_onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle>
        <TopHeader
          title={'Edit Store'}
          onClose={_onClose}
          icon={<IStore size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        <StoreForm
          validateOnInit
          onChange={(values) => {
            setFormData({ ...Object.assign(formData, values) });
          }}
          data={formData}
        />

        <div
          style={{
            marginBottom: '20px',
            marginTop: '20px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || (formData && !formData.isValid)}
            label={<span>Save Store</span>}
            onClick={() => {
              editStore();
            }}
            onEnter={() => {
              editStore();
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

EditStoreDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
};

export default EditStoreDialog;
